var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vin-wrapper", class: _vm.addToCart && "mb-2" },
    [
      _vm._t("title"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-full pt-4", attrs: { id: "vin-tool" } },
        [
          _c("loading-overlay", {
            attrs: {
              active: _vm.displayLoader,
              id: "loader",
              loader: "dots",
              color: "#1A74DB",
              height: "30",
              width: "100%",
              opacity: "0.85",
            },
            on: {
              "update:active": function ($event) {
                _vm.displayLoader = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "after",
                fn: function () {
                  return [
                    _c("h3", { attrs: { id: "loading-notice" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.webstoreContent.selectProductsPage
                              .getting_cables
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("TextAreaLineNumbers", {
            attrs: {
              value: _vm.currentVinValue,
              placeholderNumbers: "1\n2",
              placeholder: "ABCDE1234567890\nABCDE1234567891",
            },
            on: { "key-up": _vm.keyUp },
          }),
          _vm._v(" "),
          !_vm.addToCart
            ? _c(
                "div",
                { staticClass: "flex justify-center items-center flex-wrap" },
                [
                  _c("v-button", {
                    attrs: {
                      position: "right",
                      mobile: "12",
                      tablet: "12",
                      desktop: "12",
                      styling: "secondary rounded",
                      disabled: _vm.disabled || _vm.disabledDone,
                    },
                    on: { onClickEvent: _vm.submitVinData },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "content",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.submitCablesText) +
                                  "\n                    "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2405013354
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }